import storageSession from 'redux-persist/lib/storage/session';
import { AnyAction, configureStore, Dispatch, Reducer } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import { reducers } from './reducers';
import { RootState } from './hook';
import { RESET_REDUX_STORE } from './providers/storeProvider';
import setTransform from './transformStoreData';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const persistConfig: any = {
  key: 'root',
  storage: storageSession,
};

// Add cryptoJS encryption/discryption if GENERATE_REDUX_ENCRYPTION === true.
if (process.env.REACT_APP_GENERATE_REDUX_ENCRYPTION) persistConfig['transforms'] = [setTransform];

/**
 *
 * @param state
 * @param action
 * @returns combinedReducer
 * a wrapper for combinedReducers, if action.type === 'RESET_REDUX_STORE', then set redux store state = undefined
 */
const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  if (action.type === RESET_REDUX_STORE) state = undefined;
  return reducers(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const reduxStore = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const getStore = (): { dispatch: Dispatch; state: RootState } => {
  const state = reduxStore.getState();
  const { dispatch } = reduxStore;

  return { dispatch, state };
};

export const persistor = persistStore(reduxStore);
